import {RestService} from "@/services/rest/RestService";
import {PopupVisibilityRuleEndpointsApi} from "@/api/pharma-cms-popup";
import {ContentVisibilityRuleRestDto, PopupVisibilityRuleOverviewResultsRestDto} from "@/api/pharma-cms-popup/models";
import {CacheService} from "@/services/cache/CacheService";
import {CacheKeyEnum} from "@/services/cache/CacheKeyEnum";

export class PopupVisibilityRuleRestService extends RestService {

    private apiService: PopupVisibilityRuleEndpointsApi;


    protected constructor() {
        super();
        this.apiService = new PopupVisibilityRuleEndpointsApi(
            this.getDpAxiosV2Instance(),
            undefined,
            this.getConfig().cmsUrl
        );
    }

    public async getVisibilityRules(popupId: string): Promise<PopupVisibilityRuleOverviewResultsRestDto> {
        const response = await this.apiService.getPopupVisibilityRuleOverview(popupId);
        return response.data;
    }

    public async addPopupVisibilityRule(visibilityRuleRestDto: ContentVisibilityRuleRestDto, popupId: string): Promise<void> {
        await this.apiService.createPopupVisibilityRule(visibilityRuleRestDto, popupId);
    }

    public async getPopupVisibilityRule(visibilityRuleId: string): Promise<ContentVisibilityRuleRestDto> {
        const cacheKey = CacheKeyEnum.POPUP_VISIBILITY_RULE + '_' + visibilityRuleId;
        let result: ContentVisibilityRuleRestDto | undefined = CacheService.getInstance().get(cacheKey);
        if (result) {
            return result;
        }

        const response = await this.apiService.getPopupVisibilityRule(visibilityRuleId);
        result = response.data;

        CacheService.getInstance().set(cacheKey, result);
        return result;
    }

    public async updatePopupVisibilityRule(visibilityRuleId: string, visibilityRule: ContentVisibilityRuleRestDto): Promise<void> {
        await this.apiService.updatePopupVisibilityRule(visibilityRule, visibilityRuleId);
        CacheService.getInstance().invalidate(CacheKeyEnum.POPUP_VISIBILITY_RULE + '_' + visibilityRuleId);
    }

    public async deletePopupVisibilityRule(visibilityRuleId: string): Promise<void> {
        await this.apiService.deletePopupVisibilityRule(visibilityRuleId);
        CacheService.getInstance().invalidate(CacheKeyEnum.POPUP_VISIBILITY_RULE + '_' + visibilityRuleId);
    }
}
